// extracted by mini-css-extract-plugin
module.exports = {"bigMargin":"ReviewTopComponent_bigMargin__3HFUC","extraBigMarginBottom":"ReviewTopComponent_extraBigMarginBottom__3_8bk","saveButton":"ReviewTopComponent_saveButton__1Lfe5"};